import React from 'react';
import { StyledDiv } from '../styled-elements';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
function Downloads() {
  
  return (
    <div className="App border">
      <div className="border-bottom m-0 pb-2 pt-2 row align-items-center">
        <div className="col-md-6 text-left">
          <p className="mb-0 font-weight-bold">Download Details</p>
        </div>
      </div>
      <div className="bg-white m-0 row pt-2">
      <div className="col-md-12 text-left font_size_12px mt-2 mb-3">
        <button type="button" className="btn btn-success font_size_12px mt-2 pb-1 pl-3 pr-3 pt-1">Add</button>
        </div>
        <div className="col-sm-12 col-md-6 col-12">
          <div className="form-inline">
            <label className="font_size_12px">
              Show{" "}
              <select className="font_size_12px form-control form-control-sm ml-2 mr-2 p-1">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>{" "}
              entries
            </label>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 pull-r text-right col-12">
          <div>
            <label className="d-block form-inline font_size_12px">
              Search:
              <input
                type="search"
                className="form-control form-control-sm ml-1"
                placeholder=""
                aria-controls="dtBasicExample"
              />
            </label>
          </div>
        </div>
      </div>
      <table className="table table-striped mb-0 table-bordered">
        <thead>
          <tr>
            <th scope="col">Name<i className="fa fa-fw fa-sort"></i></th>
            <th scope="col">Icon<i className="fa fa-fw fa-sort"></i></th>
            <th scope="col">Pdf File<i className="fa fa-fw fa-sort"></i></th>
            <th scope="col">Delete PDF<i className="fa fa-fw fa-sort"></i></th>
            <th scope="col">Actions<i className="fa fa-fw fa-sort"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Ball Bearing Draw Slides</td>
            <td><img src="#"/></td>
            <td>Ball_Bearing_Draw_Slides1.pdf</td>
            <td></td>
            <td className="border-0">
                  <Link to={`1234`} className="pr-4 text-dark">
                    <FontAwesomeIcon icon={faEye} />
                    <span className="ml-1 mb-0">View</span>
                  </Link>
                  <Link to={`1234`} className="pr-4 text-dark">
                    <FontAwesomeIcon icon={faPencil} />
                    <span className="ml-1 mb-0">Edit</span>
                  </Link>
                  <Link to={`1234`} className="pr-4 text-dark" data-toggle="modal" data-target="#myModal">
                    <FontAwesomeIcon icon={faTrash} />
                    <span className="ml-1 mb-0">Delete</span>
                  </Link>
                </td>
          </tr>
          <tr>
            <td>Cabinet Accessories - NCA</td>
            <td><img src="#"/></td>
            <td>N18-Cabinet_Accessories.pdf</td>
            <td></td>
            <td className="border-0">
                  <Link to={`1234`} className="pr-4 text-dark">
                    <FontAwesomeIcon icon={faEye} />
                    <span className="ml-1 mb-0">View</span>
                  </Link>
                  <Link to={`1234`} className="pr-4 text-dark">
                    <FontAwesomeIcon icon={faPencil} />
                    <span className="ml-1 mb-0">Edit</span>
                  </Link>
                  <Link to={`1234`} className="pr-4 text-dark" data-toggle="modal" data-target="#myModal">
                    <FontAwesomeIcon icon={faTrash} />
                    <span className="ml-1 mb-0">Delete</span>
                  </Link>
                </td>
          </tr>
          <tr>
            <td>Cabinet Lift</td>
            <td><img src="#"/></td>
            <td>N11-Cabinet_Lift.pdf</td>
            <td></td>
            <td className="border-0">
                  <Link to={`1234`} className="pr-4 text-dark">
                    <FontAwesomeIcon icon={faEye} />
                    <span className="ml-1 mb-0">View</span>
                  </Link>
                  <Link to={`1234`} className="pr-4 text-dark">
                    <FontAwesomeIcon icon={faPencil} />
                    <span className="ml-1 mb-0">Edit</span>
                  </Link>
                  <Link to={`1234`} className="pr-4 text-dark" data-toggle="modal" data-target="#myModal">
                    <FontAwesomeIcon icon={faTrash} />
                    <span className="ml-1 mb-0">Delete</span>
                  </Link>
                </td>
          </tr>
          <tr>
            <td>Cabinet Lock</td>
            <td><img src="#"/></td>
            <td>N19-Cabinet_Locks.pdf</td>
            <td></td>
            <td className="border-0">
                  <Link to={`1234`} className="pr-4 text-dark">
                    <FontAwesomeIcon icon={faEye} />
                    <span className="ml-1 mb-0">View</span>
                  </Link>
                  <Link to={`1234`} className="pr-4 text-dark">
                    <FontAwesomeIcon icon={faPencil} />
                    <span className="ml-1 mb-0">Edit</span>
                  </Link>
                  <Link to={`1234`} className="pr-4 text-dark" data-toggle="modal" data-target="#myModal">
                    <FontAwesomeIcon icon={faTrash} />
                    <span className="ml-1 mb-0">Delete</span>
                  </Link>
                </td>
          </tr>
        </tbody>
      </table>
      <div className="align-items-baseline bg-white m-0 p-3 row">
        <div className="col-md-6 text-left">
          <p className="mb-0">Showing 1 to 10 of 57 entries</p>
        </div>
        <div className="col-md-6 text-right">
          <nav aria-label="...">
            <ul className="d-inline-flex mb-0 pagination">
            <li className="page-item disabled">
                <a className="page-link" href="#" tabIndex={-1}>
                 First
                </a>
              </li>
              <li className="page-item disabled">
                <a className="page-link" href="#" tabIndex={-1}>
                  Previous
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  1
                </a>
              </li>
              <li className="page-item active">
                <a className="page-link" href="#">
                  2 <span className="sr-only">(current)</span>
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  3
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  Next
                </a>
              </li>
              <li className="page-item disabled">
                <a className="page-link" href="#" tabIndex={-1}>
                  Last
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Downloads;
